import { render, staticRenderFns } from "./warehouse-management-card.vue?vue&type=template&id=4a193ef8"
import script from "./warehouse-management-card.vue?vue&type=script&lang=js"
export * from "./warehouse-management-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports